import React from 'react';
import styles from './styles.module.css';
function Loader() {
    return (
        <div className={styles.nfLoader}></div>
    )
}

export default Loader